import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { Grid } from '@mui/material';
import { Button, FeedbackError, Input } from '../../../../../components';

export const amenitySchema = Yup.object().shape({
  name: Yup.string().required('Amenity name is required'),
  price: Yup.number().required('Amenity price is required'),
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 5,
  p: 4,
};

function ModalEditAmenity({ open, handleClose, onSave, amenity }) {
  const [initialValues, setInitialValues] = useState({
    key: null,
    name: '',
    price: true,
  });

  useEffect(() => {
    if (amenity) setInitialValues(amenity);
  }, [amenity]);

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    setInitialValues({ key: null, name: '', price: '' });
    setSubmitting(true);
    handleClose(true);
    resetForm();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Edit
        </Typography>
        <Formik initialValues={initialValues} validationSchema={amenitySchema} onSubmit={onSave}>
          {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <Form
              onSubmit={handleSubmit}
              onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}>
              <Grid container justifyContent="space-around" paddingRight={5} marginTop={5}>
                <Grid item sm={11} marginRight={1} paddingBottom={2}>
                  <label style={{ color: 'gray', marginLeft: 5 }}> Amenity Name </label>
                  <Input
                    name="name"
                    type="text"
                    placeholder="Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.name && touched.name && 'error'}
                    style={{ marginBottom: 'unset' }}
                  />
                  <FeedbackError name="name" errors={errors} touched={touched} />
                </Grid>
                <Grid item sm={11} marginRight={1}>
                  <label style={{ color: 'gray', marginLeft: 5 }}> Amenity Price </label>
                  <Input
                    name="price"
                    type="number"
                    placeholder="Price"
                    value={values.price}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.price && touched.price && 'error'}
                    style={{ marginBottom: 'unset' }}
                  />
                  <FeedbackError name="price" errors={errors} touched={touched} />
                </Grid>
              </Grid>

              <Grid
                container
                justifyContent="center"
                paddingLeft={5}
                paddingRight={5}
                marginTop={3}>
                <Grid item sm={7}>
                  <Button type="submit" label="Edit" />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

ModalEditAmenity.defaultProps = {
  amenity: undefined,
};

ModalEditAmenity.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  amenity: PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
  }),
};

export default ModalEditAmenity;
